import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedZorroModule } from '../../shared-zorro.module';
import { SiderComponent } from '../component/sider/sider.component';
import { RouterOutlet } from '@angular/router';
import { RouterModule, Router } from '@angular/router';

@Component({
  selector: 'app-index',
  standalone: true,
  imports: [CommonModule, SharedZorroModule, SiderComponent, RouterOutlet],
  templateUrl: './index.component.html',
  styleUrl: './index.component.less',
})
export class IndexComponent {
  user: any;
  role: any;
  constructor(private router: Router) {
    this.user = JSON.parse(sessionStorage.getItem('user') || '{}');
    this.role = JSON.parse(sessionStorage.getItem('role') || '{}');
    if (!this.role?.id) {
      this.role = this.user.roles[0];
      sessionStorage.setItem('role', JSON.stringify(this.role));
    }
  }
  logout() {
    this.router.navigate(['/login']);
  }

  changeRole(role: any) {
    this.role = role;
    sessionStorage.setItem('role', JSON.stringify(role));
  }
}
